<template>
<div class="chapter">
<div class="inner_page">
<p class="autor" id="jump_to_top">Johanna Spyri</p>
<p class="titel">Heidi</p>
<p class="autor">Heidis Lehr- und Wanderjahre &amp; Heidi kann brauchen, was es gelernt hat</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title_page.vue?8ae71d56